<template>
  <div style="height:670px;width: 670px;">
    <!-- <el-image class="light-ring" :src="require('@/assets/img/lightRing.png')"></el-image> -->
    <div style="width:100%;height:100%" ref="charts"></div>
  </div>
</template>
<script>
import Map from "./../api/map.json";
import * as echarts from "echarts";
export default {
  data() {
    return {
      mapData: [],
      key: 0,
    };
  },
  mounted() {
    // this.$get().then(() => {
    // console.log(Map, echarts);
    this.getMapData();
    this.initCharts();
  },
  methods: {
    getMapData() {
      this.$get("/things/frontPage/innetSpot").then((res) => {
        // console.log(res,333333333333333333);
        this.mapData = res.data.map((item) => {
          return { name: item.c_name, coord: [item.lon, item.lat] };
        });
        this.initCharts();
      });
    },
    initCharts() {
      const charts = echarts.init(this.$refs["charts"]);
      const option = {
        // 背景颜色
        backgroundColor: "#ffffff00",
        graphic: [
          {
            type: "image",
            id: "background",
            right: "center", // 根据父元素进行定位 （居中）
            bottom: "0%", // 根据父元素进行定位   （0%）, 如果bottom的值是 0，也可以删除该bottom属性值。
            z: 0, // 层叠
            bounding: "all", // 决定此图形元素在定位时，对自身的包围盒计算方式
            style: {
              image: require("@/assets/img/lightRing.png"), // 这里一定要注意、注意，必须是https开头的图片路径地址
              width: 1200,
              height: 600,
            },
          },
        ],
        tooltip: {
          //                    show: false //不显示提示标签
          formatter: "{b}", //提示标签格式
          backgroundColor: "#ff7f50", //提示标签背景颜色
          textStyle: { color: "#fff" }, //提示标签字体颜色
        },

        // 地图配置
        series: [
          {
            center: [117.024967066, 36.6827847272],
            type: "map",
            mapType: "QD",
            roam: "scale", // 缩放&&平移
            scaleLimit: {
              min: 0.75,
              max: 2,
            },
            label: {
              // 通常状态下的样式
              normal: {
                show: true,
                textStyle: {
                  color: "#02f6ff",
                },
              },
              // 鼠标放上去的样式
              emphasis: {
                textStyle: {
                  color: "#02f6ff",
                },
              },
            },
            // 地图区域的样式设置
            itemStyle: {
              normal: {
                borderColor: "#02f6ff",
                borderWidth: 3,
                areaColor: "#02f6ff00",
                // areaColor: {
                // 	type: "radial",
                // 	x: 0.8,
                // 	y: 0.8,
                // 	r: 0.8,
                // 	colorStops: [
                // 		{
                // 			offset: 0,
                // 			color: "#02f6ff00", // 0% 处的颜色
                // 		},
                // 		{
                // 			offset: 1,
                // 			color: "#02f6ff33", // 100% 处的颜色
                // 		},
                // 	],
                // 	globalCoord: false, // 缺省为 false
                // },
                shadowColor: "#02f6ff33",
                shadowOffsetX: -2,
                shadowOffsetY: 2,
                shadowBlur: 10,
              },
              // 鼠标放上去高亮的样式
              emphasis: {
                areaColor: "#c8c5c578",
                borderColor: "#fff",
                borderWidth: 3,
              },
            },
            markPoint: {
              symbol: "pin",
              symbolSize: 30, // 标记大小
              symbolRotate: 0, // 旋转角度
              symbolOffset: [0, 0], // 偏移量
              label: "", // 标记的文本
              data: this.mapData,
            },
            data: [
              // { name: "章丘区", selected: false }, //章丘区为选中状态
            ],
          },
        ],
      };
      // 地图注册，第一个参数的名字必须和option.geo.map一致
      echarts.registerMap("QD", Map);
      charts.on("georoam", (map) => {
        option.series.center = [117.024967066, 36.6827847272];
        charts.setOption(option);
      });
      charts.setOption(option);
      charts.on("mouseover", function(params) {
        // var dataIndex = params.dataIndex;
       
      });
      charts.on("click", (param) => {
        // 可以使用下面的方式进行路由的切换
        // alert(param.name);
        this.$router.push({
          path: "/",
          // query: { swsmc: danwei }
        });
      });
      window.onresize = charts.resize;
      // window.addEventListener("resize", function() {
      //   charts.resize();
      // });
    },
  },
};
</script>
<style scope>
.light-ring {
  position: absolute;
  top: calc(100% - 700px);
  width: 100%;
  height: 600px;
  left: 10%;
}
</style>
